import { render, staticRenderFns } from "./CancelGeneralConsentEmail.vue?vue&type=template&id=5b9ea896&scoped=true&"
import script from "./CancelGeneralConsentEmail.vue?vue&type=script&lang=js&"
export * from "./CancelGeneralConsentEmail.vue?vue&type=script&lang=js&"
import style0 from "./CancelGeneralConsentEmail.vue?vue&type=style&index=0&id=5b9ea896&prod&lang=css&"
import style1 from "./CancelGeneralConsentEmail.vue?vue&type=style&index=1&id=5b9ea896&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9ea896",
  null
  
)

export default component.exports